module.exports = __webpack_public_path__ + "static/img/product_1.3b62874.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/product_1.png
// module id = ZJ8D
// module chunks = 15